<template>
    <v-sheet style="background-color:#fafafa; height:100%">
        <v-toolbar floating elevation="0" style="border-bottom:1px solid #ddd" pb-5>
            <v-btn :to="{name:'products'}" icon text dark>
                <v-icon color="black">arrow_back</v-icon>
            </v-btn>

            <v-toolbar-title>Gerenciador de ISRC</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <template v-if="$vuetify.breakpoint.smAndUp">
                    <v-btn text color="black">
                        <v-icon>save_alt</v-icon>&nbsp; Salvar Rascunho
                    </v-btn>
                </template>
                <template v-if="!$vuetify.breakpoint.smAndUp">
                    <v-btn color="primary">
                        <v-icon>save_alt</v-icon>
                    </v-btn>
                </template>
            </v-toolbar-items>
        </v-toolbar>

        <v-layout text-center style="background-color:white">
            <v-flex text-center>
                <v-btn @click="e1 = e1-1" v-if="e1>1" outlined color="primary">
                    <v-icon>first_page</v-icon>&nbsp; etapa
                </v-btn>&nbsp;&nbsp;&nbsp;&nbsp;
                <v-btn @click="e1 = e1+1" v-if="e1 != 4" outlined color="primary">
                    etapa
                    <v-icon>last_page</v-icon>&nbsp;
                </v-btn>
            </v-flex>
        </v-layout>

        <v-stepper v-model="e1" elevation="0" class="elevation-0">
            <v-stepper-header style="border:0px solid #ccc; box-shadow:none;">
                <v-stepper-step :complete="e1 > 1" step="1">Cadastro de Titulares</v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step :complete="e1 > 2" step="2">Autoral</v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step :complete="e1 > 3" step="3">Conexos</v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step :complete="e1==4" step="4">Revisar</v-stepper-step>
            </v-stepper-header>

            <v-stepper-items style="background-color:#fafafa" elevation="0">
                <v-stepper-content step="1">
                    <paineltitulares :titulares="titulares" />
                </v-stepper-content>

                <v-stepper-content step="2">

                    <painelautoral :tracks="tracks" />

                </v-stepper-content>

                <v-stepper-content step="3">
                    <v-card class="mb-12" color="grey lighten-1" height="200px"></v-card>
                </v-stepper-content>

                <v-stepper-content step="4">
                    <v-card class="mb-12" color="grey lighten-1" height="200px"></v-card>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
        {{titulares}}
    </v-sheet>
</template>

<script>
import paineltitulares from "../../../components/product/isrc/titulares";
import painelautoral from "../../../components/product/isrc/autoral";
import ProductService from "../../../app/Rest/product";


let productService = null;

export default {
    components: {
        paineltitulares,
        painelautoral
    },
    data() {
        return {
            e1: 1,
            titulares: [],
            product: {},
            tracks: [],
            product_id: null
        };
    },
    beforeCreate: function() {
        if (this.$route.params) {
            this.product_id = this.$route.params.id;
        }

        if (!this.product_id) {
            console.log( "não é possível entrar aqui sem estar associado a um produto" );
            this.$router.push({ name: "products" });
        }

        productService = ProductService.build();
        productService.getOne(this.product_id).then(e => {
            if (e.items) {
                this.product = e.items.product;
                this.tracks = e.items.tracks;
                console.log(this.product);
            }
        });
    }
};
</script>